import { useTranslations } from '@/i18n/context';

export function Reasons() {
  const t = useTranslations('reasons');
  const items = t.raw('items') as Array<{
    n: string;
    title: string;
    en: string;
    desc: string;
  }>;

  return (
    <section
      id="reasons"
      className="relative bg-[color:var(--mp-forest)] py-24 text-[color:var(--mp-cream)] md:py-40"
    >
      <div className="mx-auto max-w-[1440px] px-6 md:px-12 lg:px-20">
        <div className="mb-16 grid grid-cols-1 gap-10 md:mb-24 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="mb-4 text-[11px] uppercase tracking-[0.32em] text-[color:var(--mp-signal)]">
              {t('sectionLabel')}
            </div>
            <h2
              className="font-serif-cn text-4xl leading-[1.2] md:text-6xl"
              // eslint-disable-next-line react/no-danger -- trusted translation
              dangerouslySetInnerHTML={{ __html: t('title') }}
            />
          </div>
          <div className="md:col-span-6 md:col-start-7">
            <img
              src="https://img.alicdn.com/imgextra/i3/2216742298660/O1CN01x6vGEJ2DqL5NEWnKC_!!2216742298660.jpg"
              alt="鞋底细节 · 防滑几何纹理"
              className="aspect-[3/2] w-full object-cover grayscale-[0.15] contrast-[1.05]"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 gap-px border-t border-[color:var(--mp-cream)]/15 bg-[color:var(--mp-cream)]/15 md:grid-cols-3">
          {items.map((r) => (
            <div
              key={r.n}
              className="group relative overflow-hidden bg-[color:var(--mp-forest)] p-8 transition-colors duration-500 hover:bg-[color:var(--mp-forest-soft)] md:p-12"
            >
              <div className="font-display text-6xl text-[color:var(--mp-signal)]/70 md:text-7xl">
                {r.n}
              </div>
              <div className="mt-8 text-[11px] uppercase tracking-[0.28em] text-[color:var(--mp-cream)]/60">
                {r.en}
              </div>
              <h3 className="font-serif-cn mt-3 text-2xl leading-[1.3] md:text-3xl">
                {r.title}
              </h3>
              <p className="mt-6 text-[14px] leading-[1.9] text-[color:var(--mp-cream)]/75">
                {r.desc}
              </p>
              <div className="mt-10 h-px w-8 bg-[color:var(--mp-signal)] transition-all duration-500 group-hover:w-20" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
